import React from "react";
import ArrivalBoard from "./components/ArrivalBoard";
import "./App.css";

function App() {
  const systemId = "us-ny-subway";
  const stopId = "G12"; // Your current stop

  return (
    <div className="container">
      <ArrivalBoard systemId={systemId} stopId={stopId} />
    </div>
  );
}

export default App;
